import qs from 'qs';
import React, { useEffect, useState } from 'react';
import { Table, Input, Space, message, Form, Modal, Select } from 'antd';
import createColumns from './tableColumn';
import { http } from '../../utils';
import './index.scss'
const { Search, TextArea } = Input;
const { Option } = Select;

const getRandomuserParams = (params) => ({
  pagesize: params.pagination?.pagesize,
  current: params.pagination?.current,
  startTime: params?.startTime,
  endTime: params?.endTime,
  state: params?.state,
  order_id: params?.order_id
});

const Quote = () => {
  const [ data, setData ] = useState();
  const [ form ] = Form.useForm();
  const [ loading, setLoading ] = useState(false);
  
  const [ tableParams, setTableParams ] = useState({
    startTime: '',
    endTime: '',
    state: '',
    order_id: '',
    pagination: {
      current: 1,
      pagesize: 10
    }
  });
  
  const activate = async (record) => {
    const { quote_id: quoteId } = record;
    const { code } = await http.post(`/api/quote/activate`, {
      quoteId
    });
    if (parseInt(code, 10) === 0) {
      loadData();
      message.success('activate success');
    }
  }
  
  const cancel = async (record) => {
    setOpen(true);
    const { quote_id: quoteId } = record;
    setCurrentRecord(quoteId);
  }
  
  const columns = createColumns((record) => {
    console.log(record);
    activate(record)
  }, (record) => {
    cancel(record);
  });
  
  const loadData = async () => {
    if (loading) return;
    
    setLoading(true);
    const { results, total } = await http.get(`/api/quote/list?${qs.stringify(getRandomuserParams(tableParams))}`);
    if (results) {
      setData(results);
      setLoading(false);
      setTableParams(prev => ({
        ...prev,
        pagination: {
          ...prev.pagination,
          total: total
        }
      }));
    }
  }
  
  // Create stable dependencies string
  const deps = JSON.stringify({
    current: tableParams.pagination?.current,
    pageSize: tableParams.pagination?.pagesize,
    state: tableParams.state,
    order_id: tableParams.order_id
  });
  
  // Fetch data when dependencies change
  useEffect(() => {
    loadData();
  }, [deps]);
  
  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams(prev => ({
      ...prev,
      pagination,
      filters,
      ...sorter,
    }));

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };
  
  const onSearch = (order_id) => {
    setTableParams({
      ...tableParams,
      order_id,
      pagination: {
        current: 1,
        pagesize: 10
      }
    })
  }
  
  const [ open, setOpen ] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [ currentRecord, setCurrentRecord ] = useState('');

  const handleOk = async () => {
    try {
      const valid = await form.validateFields();
      if (valid) {
        form.submit();
      }  
    } catch(e) {
      console.log(e);
    }
  }
  
  const handleCancel = () => {
    setOpen(false);
    form.resetFields()
  };
  
  const onFinishCancel = async () => {
    const { reason, comments } = form.getFieldsValue();
    try {
      setConfirmLoading(true);
      const { code, message: msg } = await http.post(`/api/quote/cancel`, {
        reason,
        comments,
        quoteId: currentRecord
      });
      setConfirmLoading(false);
      if (parseInt(code, 10) === 0) {
        message.success('cancel success');    
      } else {
        message.error(msg);
      }
    } catch (e) {
      setConfirmLoading(false);
    }
  }
  
  const onChange = (state) => {
    setTableParams({
      ...tableParams,
      state,
      pagination: {
        current: 1,
        pagesize: 10
      }
    })
  }

  return (
    <div>
      <div className='quote-header'>Quote</div>
      <div className='quote-content'>
        <div className='quote-search'>
          <Space>
            Order Id:
            <Search
              placeholder="input order_id"
              onSearch={ onSearch }
              style={{ width: 200 }}
              allowClear
            />
            state
            <Select
              style={{ width: 100 }}
              onChange={ onChange }
              allowClear
              placeholder="all"
            >
              <Option value="">all</Option>
              <Option value="1">handoff</Option>
              <Option value="0">Pending</Option>
            </Select>
          </Space>
        </div>
        <Table
          columns={columns}
          rowKey={(record) => record.id}
          dataSource={ data }
          pagination={tableParams.pagination}
          loading={loading}
          onChange={ handleTableChange }
        >
        </Table>
        <Modal
          title="Cancel"
          open={ open }
          onOk={ handleOk }
          confirmLoading={ confirmLoading }
          onCancel={ handleCancel }
        >
          <Form
            name="cancel"
            autoComplete="off"
            form={ form }
            onFinish={onFinishCancel}
            initialValues= {{
              reason: '',
              comments: ''
            }}
            labelCol ={
              {
                xs: {
                  span: 5,
                }
              }
            }
            labelAlign="left"
          >
            <Form.Item
              label="Reason"
              name="reason"
              rules={[
                {
                  required: true,
                  message: 'Please select your Reason!',
                },
              ]}
            >
              <Select
                allowClear
              >
                <Option value="0">ORDER RETURNED</Option>
                <Option value="1">ORDER CANCELLED</Option>
                <Option value="2">INSURANCE CANCELLED</Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="Comments"
              name="comments"
              rules={[
                {
                  required: true,
                  message: 'Please input your comments!',
                },
              ]}
            >
              <Space className='model-content-space'>
                <TextArea
                  rows={4}
                  placeholder="Comments"
                />
              </Space>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </div>
  )
}

export default Quote;